import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { Filters, getAllItems } from "./api";

import type { Item } from "@entities/item";
import type { PageOf } from "@shared/types/misc";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";

export const useItemsQuery = (
  options: Partial<UseQueryOptions<PageOf<Item>>> &
    Partial<{ filters: Filters }> = {},
) => {
  const { activeCompany } = useAuthenticationContext();

  return useQuery({
    queryKey: ["item", { companyId: activeCompany?.id }, { ...options.filters }],
    queryFn: () => getAllItems(options?.filters),
    ...options,
    enabled: !!activeCompany && (options.enabled ?? true),
  });
};
